import type { AllRouteEndpoints } from "../routeTypes";

export const engagementEmailTemplatesId = "/engagement/email_templates/:id";
export const engagementEmailTemplatesIdCacheKeys: AllRouteEndpoints[] = ["/engagement/email_templates/:id"];
